import {
  ChangeDetectionStrategy,
  Component,
  InputSignal,
  InputSignalWithTransform,
  booleanAttribute,
  effect,
  input
} from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { TiimeInputContainerModule, TiimeSelectModule, TiimeOptionModule } from 'tiime-material';

import { SelectBase } from '@bases/selector/select.base';
import { AuditEntityType } from '@enums/audit-entity-type.enum';
import { MissionAcceptanceStatus } from '@enums/mission-acceptance-status.enum';
import { BusinessUser } from '@models/business-user';
import { CodeAndLabel } from '@models/code-and-label';
import { BooleanInputType } from '@modules/core/types/boolean-input.type';
import { StatusType } from '@modules/core/types/status-type.type';
import { HistoryInfosButtonComponent } from '@shared-components/history-infos-button/history-infos-button.component';
import { StatusComponent } from '@shared-components/status/status.component';
import { AtByPipe } from '@shared-pipes/at-by/at-by.pipe';
import { CodeAndLabelPipe } from '@shared-pipes/code-and-label/code-and-label.pipe';
import { DisabledMissionAcceptanceStatusPipe } from '@shared-pipes/disabled-mission-acceptance-status/disabled-mission-acceptance-status.pipe';
import { StatusColorPipe } from '@shared-pipes/status-color/status-color.pipe';

@Component({
  selector: 'app-mission-acceptance-status-select',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    TiimeInputContainerModule,
    TiimeSelectModule,
    TiimeOptionModule,
    StatusColorPipe,
    StatusComponent,
    AtByPipe,
    CodeAndLabelPipe,
    DisabledMissionAcceptanceStatusPipe,
    HistoryInfosButtonComponent
  ],
  templateUrl: './mission-acceptance-status-select.component.html',
  styleUrls: ['./mission-acceptance-status-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MissionAcceptanceStatusSelectComponent extends SelectBase<CodeAndLabel<MissionAcceptanceStatus>> {
  readonly status: InputSignal<MissionAcceptanceStatus> = input<MissionAcceptanceStatus>();
  readonly statusId: InputSignal<number> = input<number>();
  readonly statusAt: InputSignal<Date> = input<Date>();
  readonly statusBy: InputSignal<BusinessUser> = input<BusinessUser>();
  readonly label: InputSignal<string> = input<string>('État');
  readonly statusDisabled: InputSignalWithTransform<boolean, BooleanInputType> = input<boolean, BooleanInputType>(
    false,
    {
      transform: booleanAttribute
    }
  );

  readonly statusType: StatusType = 'missionAcceptance';
  readonly historyEntityType = AuditEntityType.missionAcceptances;
  readonly historyEntityTitle = 'État acceptation de mission';

  constructor() {
    super();
    effect(() => this.setDisabled(this.statusDisabled()));
  }
}
